import { WidgetCard } from 'src/v2/components/widget-card'
import { Colors } from 'src/components/theme'
import { AcquisitionsOverviewFilters } from 'src/v2/views/owner-reveal/insights/acquisition-history/acquisitions-overview/filters'
import { AcquisitionsOverviewContent } from 'src/v2/views/owner-reveal/insights/acquisition-history/acquisitions-overview/content'

export const AcquisitionsOverview = () => {
  return (
    <WidgetCard
      id="acquisitions-overview"
      title="Acquisitions Overview"
      headerBgColor={Colors.primaryRed700}
      headerTextColor={Colors.textWhite}
      filters={<AcquisitionsOverviewFilters />}
      sections={[
        {
          content: <AcquisitionsOverviewContent />,
        },
      ]}
    />
  )
}
